var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ks-form-section"},[_c('ks-form-divider',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"form-section",class:[_vm.sectionClass]},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }